import { GoabButton, GoabSpacer, GoabText } from "@abgov/react-components";
import { ErrorPage } from "../../MPP-Common-SPA/components/ErrorPage/ErrorPage";
import { getLoggedOutEndpoint } from '../../ServiceUtils/auth';
import { useLogin } from '../../PortalRunner/hooks/useLogin';
import lock from '../../MPP-Common-SPA/assets/lock.svg';

const NotAuthorized = () => {
  const { handleLogout } = useLogin();

  return (
      <ErrorPage
        heading="Access to this page is restricted"
        icon={lock}
        iconAlt="Lock"
      >
        <GoabText maxWidth="none" mb="0">
          Please check if you are accessing the correct application.
        </GoabText>
        <GoabText maxWidth="none" mb="0">
          Contact <a href="mailto:EEPSupport@gov.ab.ca" style={{ color: '#0070C4', textDecoration: 'underline' }}>EEPSupport@gov.ab.ca</a> if you require assistance.
        </GoabText>
        <>
          <GoabSpacer vSpacing={"xl"} />
          <GoabButton
            type="primary"
            onClick={() => handleLogout(getLoggedOutEndpoint())}
          >
            Go to workspace
          </GoabButton>
        </>
      </ErrorPage>
    );
};

export default NotAuthorized;